import React, { useState, useEffect } from 'react'
import * as moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { FORMAT } from 'web/components/utils/dateOfBirthValidation';
import Button from 'web/components/Button';
import { TrackDetail, DownloadBOL, TrackBox, TrackDescription, Msg } from './trackDetailTypeOneStyled'
import { fetchLanguageContentNew } from 'redux/actions/language';

const TrackDetailTypeOne = ({ items, callBackFun,resolvedWithExchange, canceledOrderCallBack, rescheduleCallBack, downloadCallBack, modalCallBack }) => {
    const dispatch = useDispatch();
    const [requestType, setRequestType] = useState()
    const [cancelOrderId, setCancelOrderId] = useState()
    const [cancelOrderModal, setCancelOrderModal] = useState(false);
    const cancelOrderToggleModal = () => setCancelOrderModal(!cancelOrderModal);

    const currentLanguage = useSelector(state => state.language.currentLanguage)
    const languageContentNew = useSelector(state => state.language.languageContentNew)
    const [pageLanguageContents, setPageLanguageContents] = useState()
    const [statusArr, setStatusArr] = useState([])

    useEffect(() => {
        if (languageContentNew?.My_Orders_Page) setPageLanguageContents(languageContentNew.My_Orders_Page)
        else dispatch(fetchLanguageContentNew(currentLanguage));
    }, [languageContentNew])

    useEffect(() => {
        setStatusArr([pageLanguageContents?.DetailedContents[13]?.Shipped,
        pageLanguageContents?.DetailedContents[16]?.Delivered])
    }, [pageLanguageContents])

    const orderTabs = (index) => {
        return (<>
            <div className="tracking-details">
                <ul className={items.userType !== "BUYER" ? "delivery-timeline" : 'delivery-timeline-buyer'}>
                    {/* <ul className="delivery-timeline"> */}
                    {index === 0 && <>
                        <li className={items.userType !== "BUYER" ? "ordered" : items.orderStatus === "SHIPPED" ? 'active' : ''}>
                            {/* <li className="ordered"> */}
                            <div className="d-icon">
                                <span>{pageLanguageContents?.DetailedContents[26]?.Order}</span>
                            </div>
                        </li>
                        <li className={items.userType !== "BUYER" ? items.orderStatus === "SHIPPED" ? 'accepted' : "shipping pending" : items.orderStatus === "DELIVERED" ? 'active' : ''} onClick={() => {
                        }}>
                            {/* <li onClick={() => {
                        }}> */}
                            <div className="d-icon">
                                {items.orderStatus === "SHIPPED" ? <span>{pageLanguageContents?.DetailedContents[13]?.Shipped}</span> : <>
                                    <span>{pageLanguageContents?.DetailedContents[14]?.Shipping}</span>
                                    <span className="status">{pageLanguageContents?.DetailedContents[15]?.Pending}</span>
                                </>}
                            </div>
                        </li>
                        <li className={items.userType !== "BUYER" ? items.orderStatus === "DELIVERED" ? 'delivered active' : "delivered pending" : items.orderStatus === "DELIVERED" ? '' : ''}>
                            {/* <li> */}
                            <div className="d-icon">
                                {items.orderStatus === "DELIVERED" ? <span>{pageLanguageContents?.DetailedContents[16]?.Delivered}</span> : <>
                                    <span>{pageLanguageContents?.DetailedContents[17]?.Delivery}</span>
                                    <span className="status">{pageLanguageContents?.DetailedContents[15]?.Pending}</span>
                                </>}
                            </div>
                        </li></>}
                </ul>
            </div>
        </>
        )
    }

    const acceptReject = () => {
        return <>
            {items.rescheduleOrder && items.rescheduleOrder.requestedUserType !== items.userType ? (
                <TrackDescription>
                    <TrackDetail>
                        <TrackBox>
                            {items.rescheduleOrder.requestedUserType === "BUYER" ?
                                <Msg>{items.buyerInfo.companyName} {pageLanguageContents?.DetailedContents[18]?.Alert3} {moment(items.rescheduleOrder.buyerRescheduledDate).format(FORMAT)}?</Msg>
                                : <Msg>{items.sellerInfo.companyName} {pageLanguageContents?.DetailedContents[18]?.Alert3} {moment(items.rescheduleOrder.sellerRescheduledDate).format(FORMAT)}?</Msg>
                            }
                            <TrackDescription>
                                <Button
                                    type='app-green-button'
                                    handleClick={() => {
                                        rescheduleCallBack(items.id, "ACCEPTED")
                                    }}>
                                    {pageLanguageContents?.DetailedContents[19]?.Accept}
                                </Button>
                                <Button
                                    type='app-green-button'
                                    handleClick={() => {
                                        if (items.orderDetails.postType === "INVENTORY" && items.rescheduleOrder && items.rescheduleOrder.requestedUserType === "SELLER" && items.userType === "SELLER") {
                                            setCancelOrderId(items.id)
                                            setRequestType("REJECTED")
                                            cancelOrderToggleModal()
                                        } if (items.orderDetails.postType === "POSTLOAD" && items.rescheduleOrder && items.rescheduleOrder.requestedUserType === "BUYER" && items.userType === "BUYER") {
                                            setCancelOrderId(items.id)
                                            setRequestType("REJECTED")
                                            cancelOrderToggleModal()
                                        } else {
                                            rescheduleCallBack(items.id, "REJECTED")
                                        }
                                    }}>
                                    {pageLanguageContents?.DetailedContents[20]?.Reject}
                                </Button>
                            </TrackDescription>
                        </TrackBox>
                    </TrackDetail>
                </TrackDescription>) : <TrackBox><Msg>{pageLanguageContents?.DetailedContents[21]?.Alert4}</Msg> </TrackBox>
            }</>
    }

    const shippedDelivered = () => {
        return <>
            {items.shippingStatusDetails && items.shippingStatusDetails.length !== 0 ?
                (<>{statusArr.map((shippingItems, index) => (
                    <>{items.shippingStatusDetails[index] ? <>
                        <>{statusArr[index] === items.shippingStatusDetails[index].shippingStatus && items.shippingStatusDetails[index].set === true ?
                            <div className="active">
                                {orderTabs(index)}
                                <div>
                                    <p style={{textAlign: 'center'}}>{moment(items.shippingStatusDetails[index].createdBuyerTime).format("hh:mm A")}, {moment(items.shippingStatusDetails[index].createdBuyerTime).format(FORMAT)}</p>
                                </div>
                            </div> : <>{orderTabs(index)}</>}</>
                    </> : orderTabs(index)}</>
                ))}</>
                ) : <>{statusArr.map((itemsVal, index) => (orderTabs(index)))}</>
            }
        </>
    }
    return (
        <>
            <TrackDetail>
                {items.orderStatus === "RESCHEDULED" &&
                    acceptReject()
                }
                {items.orderStatus === "ASSIGNED" && !items.rescheduleOrder &&
                    <TrackBox>
                        {items.userType === "SELLER" && items.sellerCancelledTimeLeft !== 0 && <>
                        </>}

                        {items.userType !== "SELLER" && items.buyerCancelledTimeLeft !== 0 && <>
                        </>
                        }
                        {shippedDelivered()}
                    </TrackBox>
                }

                {items.orderStatus === "SHIPPED" &&
                    <TrackBox>
                        {items.userType === "SELLER" && items.sellerCancelledTimeLeft !== 0 && <>
                        </>
                        }

                        {items.userType !== "BUYER" && items.buyerCancelledTimeLeft !== 0 && <>
                        </>
                        }
                        {shippedDelivered()}
                    </TrackBox>
                }
                {items.orderStatus === "ASSIGNED" && items.rescheduleOrder && (items.rescheduleOrder.rescheduleOrderStatus === "ACCEPTED" || items.rescheduleOrder.rescheduleOrderStatus === "PENDING") &&
                    <TrackBox>
                        {/*  && items.rescheduleOrder ?.rescheduleOrderStatus !== "ACCEPTED" */}
                        {!items.isClaimed &&  items.rescheduleOrder?.rescheduleOrderStatus !== "PENDING" && !resolvedWithExchange &&
                            <>
                            <Msg>{pageLanguageContents?.DetailedContents[22]?.Alert5}</Msg>
                                <div className="mx-0 px-3">
                                    {/* <p className="rescheduleMsg">
                                    <span className="bold">{pageLanguageContents?.DetailedContents[23]?.RescheduledDeliveryDate} </span>
                                    {items.contactInfo.requestedDate === null ? <span>{pageLanguageContents?.DetailedContents[24]?.NA}</span> : <span>{moment(items.rescheduleOrder && items.rescheduleOrder.buyerRescheduledDate).format(FORMAT)}</span>}
                                    </p> */}
                                </div>
                            </>
                        }
                        {shippedDelivered()}
                    </TrackBox>
                }
            </TrackDetail>
        </>
    )
};

export default TrackDetailTypeOne;
